'use client';

import { Suspense } from 'react';

import { Footer, GlobalNav } from '@/components';
import { shouldShowMessageBanner } from '@/components/nav-v2/GlobalNav/MessageBanner/helpers';

import {
  TypeGlobalNav,
  TypeFooter,
  TypeSubFooter,
} from '@/core/generated-types';

interface ClientContentLayoutProps {
  globalNav: TypeGlobalNav | null;
  footer: TypeFooter | null;
  footerLegal: TypeSubFooter | null;
  children: React.ReactNode;
}

export default function ClientContentLayout({
  globalNav,
  footer,
  footerLegal,
  children,
}: ClientContentLayoutProps) {
  const shouldShowBanner =
    globalNav?.fields && shouldShowMessageBanner(globalNav.fields);

  const bannerHeight = 53;

  const navHeight = 64;

  const loadingHeight = shouldShowBanner ? navHeight + bannerHeight : navHeight;

  return (
    <Suspense>
      <div style={{ minHeight: `${loadingHeight}px` }}>
        {globalNav && <GlobalNav {...globalNav.fields} />}
      </div>

      <main className="min-h-[600px]">{children}</main>

      {footer && footerLegal && (
        <Footer footer={footer} footerLegal={footerLegal} />
      )}
    </Suspense>
  );
}
